import { forgotPassword } from "#/src/services/auth";
import { FORGOT_PASSWORD, FORGOT_PASSWORD_FAILED } from "#/src/constants";
import { registerMixpanelEvent } from "#/src/utils/_mixpanel";

export const useForgotPassword = () => {
  const { mutation } = forgotPassword();

  const submitForgotPassword = async (
    email: string,
    {
      onSuccess,
      onError,
    }: {
      onSuccess: () => void;
      onError: (error: Error) => void;
    },
  ) => {
    try {
      registerMixpanelEvent(FORGOT_PASSWORD, {
        oem: window.location.pathname
          .split("/")
          .slice(-1)
          .join("")
          .split("?")[0],
        userEmail: email,
      });

      await mutation({ email });
      onSuccess();
    } catch (error) {
      registerMixpanelEvent(FORGOT_PASSWORD_FAILED, {
        oem: window.location.pathname
          .split("/")
          .slice(-1)
          .join("")
          .split("?")[0],
        userEmail: email,
      });
      onError(error as Error);
    }
  };

  return {
    submitForgotPassword,
  };
};
